import React, { useCallback, useRef, useState, useEffect } from 'react';

import { Link, useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';

import * as Yup from 'yup';
import QrReader from 'react-qr-reader';

import { Container, Content, AnimatedDiv, Fixed } from './styles';

import Button from '../../core/components/Forms/Button';
import getValidationErrors from '../../../../utils/getValidationErrors';
import api from '../../../../services/api';
import { useToast } from '../../../../hooks/Toast';

import { useAuth } from '../../../../hooks/Auth';
import { isUuid } from 'uuidv4';



interface ICheckin {
  accept_multiple?: number;
  room_id?: number;
  title?: string;
}

interface IStudents {
  name: string;
  document_number: string;
  user_hash: string;
}

const CheckinQR: React.FC<ICheckin> = ({
  accept_multiple = 2,
  room_id = 0,
  title = 'Leitor',
}) => {
  const history = useHistory();
  const { addToast } = useToast();
  const [withPassword, setWithPassword] = useState(false);
  const formRef = useRef<FormHandles>(null);
  const [result, setResult] = useState('');
  const [camera, setCamera] = useState('environment');
  const [lastBeep, setLastBeep] = useState('');
  const [responseStatus, setResponseStatus] = useState(false);
  const [responseMessage, setResponseMessage] = useState(<></>);
  const [option, setOption] = useState(2);
  const [quantity, setQuantity] = useState(0);
  const [inputValue, setInputValue] = useState('');
  const { user } = useAuth();

  const ref = useRef(null);
  const [currentRoom, setCurrentRoom] = useState('');

  useEffect(() => {

    if (!user) {
      window.location.href = '/';
    }

    if (user.profile !== 8 && user.profile !== 4 && user.profile !== 1) {
      window.location.href = '/';
    }

    const load = async () => {

      if (!currentRoom) {
        return;
      }

      const response = await api.post('/checkin-online', { room_id: currentRoom });
      if (response && response.data) {

        setQuantity(response?.data?.count || 0);
      }
    }

    const time = setInterval(() => {
      load();
    }, 2000);



    return () => clearInterval(time)
  }, [currentRoom]);



  const beep = () => {
    const snd = new Audio(
      'data:audio/wav;base64,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',
    );
    snd.play();
  };

  function beeps(vol, freq, duration) {
    const a = new AudioContext(); // browsers limit the number of concurrent audio contexts, so you better re-use'em
    const v = a.createOscillator();
    const u = a.createGain();
    v.connect(u);
    v.frequency.value = freq;
    v.type = 'square';
    u.connect(a.destination);
    u.gain.value = vol * 0.01;
    v.start(a.currentTime);
    v.stop(a.currentTime + duration * 0.001);
  }

  const clearAll = () => {
    setResponseStatus(false);
    setResponseMessage(<></>);
    setResult('');
    setLastBeep('');
  };

  const loadResult = response => {
    if (!response) {
      setResponseMessage(
        <Fixed background="orange">
          <h2>Erro ao identificar cadastro</h2>
          <button onClick={clearAll}>Fechar</button>
        </Fixed>,
      );
    }

    if (response.status === 1) {
      setResponseMessage(
        <Fixed background="orange">
          <h2>Acesso não autorizado</h2>
          <strong>{response.name}</strong>
          <p>{response.company}</p>
          <p>{response.position}</p>
          <p>{response.facebook}</p>
          <button onClick={clearAll}>Fechar</button>
        </Fixed>,
      );
      beep();
      beep();
    }

    if (response.status === 2) {
      setResponseMessage(
        <Fixed background={response.type_id === 2 ? 'green' : 'blue'}>
          <h2 style={{ fontSize: '36px', marginBottom: '20px' }}>{response.type_id === 2 ? 'Entrada' : 'Saída'}</h2>
          <strong style={{ fontSize: '32px', marginBottom: '20px' }}>{response.name}</strong>
          <p>{response?.company}</p>
          <p>{response?.position}</p>
          <p>{response?.facebook}</p>
          <button onClick={clearAll}>Fechar</button>
        </Fixed>,
      );
      beep();
    }

    if (response.status === 3) {
      setResponseMessage(
        <Fixed background="orange">
          <h2>Participante não identificado</h2>
          <button onClick={clearAll}>Fechar</button>
        </Fixed>,
      );
      beep();
      beep();
    }

    if (response.status === 4) {
      setResponseMessage(
        <Fixed background="purple">
          <h2>Ingresso não identificado</h2>
          <button onClick={clearAll}>Fechar</button>
        </Fixed>,
      );
      beep();
      beep();
    }

    if (response.status === 5) {
      setResponseMessage(
        <Fixed background="purple">
          <h2>Ingresso não é Físico</h2>
          <button onClick={clearAll}>Fechar</button>
        </Fixed>,
      );
      beep();
      beep();
    }
    if (response.status === 6) {
      beep();
      setResponseMessage(
        <Fixed background="red">
          <h2>Já acessou</h2>
          <strong>{response.name}</strong>
          <p>{response.company}</p>
          <p>{response.product}</p>
          <button onClick={clearAll}>Fechar</button>
        </Fixed>,
      );
      beeps(10, 320, 350);
    }

    setResponseStatus(true);
    setTimeout(() => clearAll(), 3000);
  };

  const handleSubmit = async (data: string, room) => {
    try {
      const response = await api.post('/checkin', {
        hash: data,
        room_id: room,
        accept_multiple,
      });

      if (response && response.data) {
        loadResult(response.data);
      }
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);
      }

      addToast({
        type: 'error',
        title: 'Erro ao verificar',
        description: 'Ocorreu um erro ao verificar o código',
      });
    }
  };

  const callFocus = (input) => {
    if (input) {
      input.focus();
    }
  }

  const checkuuid = async (value) => {

    if (isUuid(value)) {

      await handleScan(value);
      setInputValue('');
      callFocus(ref?.current);
    }
  }

  const handleScan = async data => {
    setResult(data);
    if (data && data !== lastBeep) {
      setLastBeep(data);
      handleSubmit(data, currentRoom);
      setResult(data);
    }
  };

  const handleError = err => {
    console.error(err);
  };

  const [input2Value, setInput2Value] = useState('');
  const [studentsList, setStudentsList] = useState<Array<IStudents>>([]);

  const search = async (input) => {

    const read = await api.post('/searchforcheckin', { search: input });

    setStudentsList(read?.data || []);
  }

  useEffect(() => {
    if (input2Value?.length >= 3) {
      search(input2Value);
    }
  }, [input2Value]
  )

  return (<>
    <div style={{ background: '#333', color: '#fff', padding: '10px', fontSize: '18px', textAlign: 'center', marginTop: '20px' }}>
      {quantity} no local
    </div>
    <div style={{ display: 'flex', flexWrap: 'wrap', width: '100%', justifyContent: 'center', alignItems: 'center' }}> <Button onClick={() => setOption(1)}>Câmera</Button>
      <Button onClick={() => setOption(2)}>Leitor de QR</Button>
      <Button onClick={() => setOption(3)}>Manual</Button>
    </div>

    <Container>
      <div style={{ display: 'flex', justifyItems: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
        <h2 style={{ padding: '5px', margin: '10px auto' }}>Porta</h2>
        <select style={{ padding: '10px 5px', margin: '10px auto' }} onChange={(e) => setCurrentRoom(e.target.value)}>
          <option selected={currentRoom === ''} value="">Selecionar Porta</option>
          <option selected={currentRoom === '8'} value="8">Insight House</option>
          <option selected={currentRoom === '9'} value="9">Hub Pelotas Parque Tecnológico</option>
          <option selected={currentRoom === '10'} value="10">Hub Rio Grande</option>
          <option selected={currentRoom === '11'} value="11">Hub dos Vales</option>

        </select>
      </div>
    </Container>

    <Container>
      {responseStatus && responseMessage}
      <Content>


        {option === 1 &&
          <AnimatedDiv>
            <h2>{title}</h2>
            <select name="camera" onChange={e => setCamera(e.target.value)}>
              <option value="environment">Padrão</option>
              <option value="user">Alternativa</option>
            </select>
            <div style={{ width: '100%', maxWidth: '100%', height: '100vh' }}>
              <QrReader
                facingMode={camera}
                delay={1000}
                onError={handleError}
                onScan={handleScan}
                style={{ width: '100%' }}
              />

              <p>{result}</p>
            </div>
          </AnimatedDiv>}

        {option === 2 &&
          <AnimatedDiv>
            <h2>Utilize o leitor de QRCode</h2>

            <div style={{ width: '100%', maxWidth: '100%', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <input ref={ref} style={{ minHeight: '40px', margin: '10px auto', padding: '20px', width: '80%', maxWidth: '600px' }} autoFocus onChange={(e) => { setInputValue(e.target.value); checkuuid(e.target.value) }} value={inputValue} />
              <Button style={{ margin: '10px auto' }} onClick={() => setInputValue('')}>Limpar</Button>

              <p>{result}</p>
            </div>


          </AnimatedDiv>

        }

        {option === 3 &&
          <AnimatedDiv>
            <h2>Pesquisa</h2>

            <div style={{ width: '100%', maxWidth: '100%', height: '100vh', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <input ref={ref} style={{ minHeight: '40px', margin: '10px auto', padding: '20px', width: '80%', maxWidth: '600px' }} autoFocus onChange={(e) => { setInput2Value(e.target.value); }} value={input2Value} />

              {studentsList.map(student => {
                return <button className="shadowButton" style={{ width: '80%', maxWidth: '600px', margin: '5px auto' }} onClick={() => handleSubmit(student?.user_hash, currentRoom)}>{student?.name}<br />{student?.document_number}</button>
              })}

              <Button style={{ margin: '10px auto' }} onClick={() => setInputValue('')}>Limpar</Button>


            </div>


          </AnimatedDiv>

        }



      </Content>
    </Container>
  </>
  );
};

export default CheckinQR;
